module.exports = __webpack_public_path__ + "static/media/boba_marker-2.d1496f7c.png";